import { render, staticRenderFns } from "./JsonLdEvent.vue?vue&type=template&id=508dd3ab&"
import script from "./JsonLdEvent.vue?vue&type=script&lang=js&"
export * from "./JsonLdEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports